import { render, staticRenderFns } from "./Profile.vue?vue&type=template&id=70f5e5ec&scoped=true&"
import script from "./Profile.vue?vue&type=script&lang=ts&"
export * from "./Profile.vue?vue&type=script&lang=ts&"
import style0 from "./Profile.vue?vue&type=style&index=0&id=70f5e5ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../boss_taobao/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f5e5ec",
  null
  
)

export default component.exports